/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/interface-name-prefix */
import {
  onMounted, reactive, ref, watch,
} from 'vue';
import {
  useRoute, useRouter, RouteLocationNormalizedLoaded, Router,
} from 'vue-router';
import { message } from 'ant-design-vue';
import commonStore from '@/store/common';
import axios from '@/axios/api';

import { mock } from '@/axios/fetch';
import MockPath from '@/mock/mock_api';
import { definitions } from '@/types/api';
import { getJobStatus } from '@/hooks/analysis.hooks';
import { GetJobStatus } from '@/interface/analysis.interface';
import analysisService from '@/services/analysis.services';
import { DataJobView, JobViewTable } from './interface';

const mockPath = new MockPath();
const { saveTeacherAdvanceEnd } = analysisService();

// 数据转换
export const apiQueryJobView = (data: definitions['AssignHomework']) => ({
  ...data,
  jobName: data.assignmentName,
  // assignStatus: i % 3, // 真的，但是后端字段是死的
  gradeStatus: data.publishStates ? 1 : 0, // boolean转 1 ｜ 0
  jobStatus: getJobStatus(data as GetJobStatus), // 后端字段死的，先模拟一下
  pattern: data.assignmentModel === 0 ? '练习模式' : '考核模式',
});
const apiListJobView = (list: definitions['AssignHomework'][]) => list.map((v) => apiQueryJobView(v));

export class JobView {
  quering = ref(false)

  loadings = reactive({
    deleting: false, // 删除
    advanceing: false, // 提前结束
  })

  data: JobViewTable = reactive({
    list: [],
    pagination: {
      pageNo: 1,
      pageSize: 12,
      totalRecords: 0,
    },
  });

  columns = ref([
    {
      title: '作业名称',
      dataIndex: 'assignmentName',
      width: '18%',
      ellipsis: true,
      key: 'assignmentName',
    },
    {
      title: '班级',
      dataIndex: 'className',
      width: '18%',
      ellipsis: true,
      key: 'className',
    },
    {
      title: '模式',
      dataIndex: 'pattern',
      width: '8%',
      key: 'pattern',
    },
    {
      title: '开始时间',
      dataIndex: 'beginTime',
      width: '15%',
      key: 'beginTime',
    },
    {
      title: '结束时间',
      dataIndex: 'endTime',
      width: '15%',
      key: 'endTime',
    },
    {
      title: '作业状态',
      dataIndex: 'jobStatus',
      width: '8%',
      key: 'jobStatus',
    },
    // {
    //   title: '发布状态',
    //   dataIndex: 'publishStates',
    //   width: '8%',
    //   key: 'publishStates',
    // },
    {
      title: '操作',
      width: '20%',
      align: 'center',
      slots: {
        customRender: 'operation',
      },
    },
  ])

  modals = reactive({
    delete: false, // 删除
    advance: false, // 提前结束
  })

  route: RouteLocationNormalizedLoaded;

  router: Router;

  activeExpId = ref('');

  initPage() {
    let pageNo = 1;
    try {
      pageNo = parseInt(this.route.query.pageNo as unknown as string, 10);
      if (Number.isNaN(pageNo) || this.route.query.activeFrame !== '1') {
        pageNo = 1;
      }
    } catch (e) {
      pageNo = 1;
    }
    this.data.pagination.pageNo = pageNo;
  }

  constructor() {
    this.route = useRoute();
    this.router = useRouter();

    watch(() => this.data.pagination.pageNo, () => {
      this.router.push({
        path: this.route.path,
        query: { ...this.route.query, ...{ pageNo: this.data.pagination.pageNo } },
      });
    });

    onMounted(() => {
      this.initPage();
      this.queryJobView();
    });
  }

  async queryJobView() {
    this.quering.value = true;
    const qdata = {
      pageNo: this.data.pagination.pageNo,
      pageSize: this.data.pagination.pageSize,
    };
    // const { data } = await mock.post(mockPath.getJobView, qdata);
    const fData = new FormData();
    fData.append('pageNo', qdata.pageNo as unknown as string);
    fData.append('pageSize', qdata.pageSize as unknown as string);
    fData.append('teacher', commonStore.getState().code);
    const { data } = await axios.listAssignHomework(fData);
    this.data.list.length = 0;
    Object.assign(this.data.list, apiListJobView(data.data.list));
    this.data.pagination.totalRecords = data.data.totalRecords;
    this.quering.value = false;
  }

  async delJobView() {
    this.loadings.deleting = true;
    // const { data } = await mock.post(mockPath.delJobView, [1]);
    const { data } = await axios.delAssignHomeworkById(this.activeExpId.value);
    if (data.success) {
      message.success('删除成功');
    }
    this.loadings.deleting = false;
  }

  async advanceJobView() {
    this.loadings.advanceing = true;
    const { data } = await saveTeacherAdvanceEnd(this.activeExpId.value);
    if (data.success) {
      message.success('操作成功');
    }
    this.loadings.advanceing = false;
  }

  async exportJobView() {
    const { data = 'a.zip' } = await mock.post(mockPath.delJobView, [1]);
    if (data) {
      window.location.href = 'https://www.7-zip.org/a/7z1900-x64.exe';
      message.success('导出成功');
    }
  }
}

export class JobViewController {
  jobView: JobView;

  route!: RouteLocationNormalizedLoaded

  router!: Router

  constructor(jobView: JobView) {
    this.route = useRoute();
    this.router = useRouter();
    this.jobView = jobView;
  }

  handlePageChange(page: number) {
    this.jobView.data.pagination.pageNo = page;
    this.jobView.queryJobView();
  }

  handleViewClick(record: DataJobView) {
    console.log(record, 'record');
    this.jobView.activeExpId.value = record.id;
    this.router.push({
      path: `/Teacher/caseAnalysis/jobDetailList/${this.jobView.activeExpId.value}`,
      query: {
        ...record,
        // homeWork: record,
        redirect: `${this.route.path}?activeFrame=1&pageNo=${this.jobView.data.pagination.pageNo}`,
      },
    });
  }

  async handleExportClick(record: DataJobView) {
    this.jobView.activeExpId.value = record.id;
    await this.jobView.exportJobView();
  }

  handleDelClick(record: DataJobView) {
    this.jobView.activeExpId.value = record.id;
    this.jobView.modals.delete = true;
  }

  handleAdvanceClick(record: DataJobView) {
    this.jobView.activeExpId.value = record.id;
    this.jobView.modals.advance = true;
  }

  async confirmDelJobView() {
    await this.jobView.delJobView();
    this.jobView.modals.delete = false;
    this.jobView.queryJobView();
  }

  async confirmAdvanceJobView() {
    await this.jobView.advanceJobView();
    this.jobView.modals.advance = false;
    this.jobView.queryJobView();
  }

  cancelDelJobView() {
    this.jobView.modals.delete = false;
  }

  cancelAdvanceJobView() {
    this.jobView.modals.advance = false;
  }
}
